<template>
  <div class="content">
    <div class="rule">
      <span class="ruleMsg" @click="handleChange">
        <i></i>
        <span>活动规则</span>
      </span>
    </div>
    <div class="common guessing">
      <p class="msg">{{msg.title}}</p>
      <p class="photo"></p>
      <p class="count">
        累计积分 (投票需
        <span style="color:#f03332;">{{msg.maxPoints}}积分</span> )
      </p>
      <p class="num">{{allpoints}}</p>
      <div class="choice">
        <div class="select" style="margin-left:10px;" @click="handleSelect(1)">
          <img src="../assets/yes2.png" alt="yes">
          <p class="supportYes">
            {{msg.option1}}
            <span>({{msg.option1Num}}人)</span>
          </p>
        </div>
        <div class="vs">VS</div>
        <div class="select" @click="handleSelect(2)">
          <img src="../assets/no2.png" alt="no">
          <p class="supportNo">
            {{msg.option2}}
            <span>({{msg.option2Num}}人)</span>
          </p>
        </div>
      </div>
    </div>
    <transition name="fade">
      <Rule v-if="open.Rule" @cancle="handleChange" :idx="1"/>
    </transition>
  </div>
</template>

<script>
import Rule from "./Rule";
import { quiz_answer ,quiz_topic} from "../../utils/config";
export default {
  props: {
    url: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    Rule
  },
  data: () => ({
    open: {
      Rule: false
    },
    title: "",
    msg: [],
    allpoints: 0
  }),
  mounted() {
    this.initGuess();
  },
  methods: {
    handleChange() {
      this.open.Rule = !this.open.Rule;
    },
    handleSelect(idx) {
      let arr = [this.msg.option1Points, this.msg.option2Points];
      if (this.url.from == "ldq") {
        this.$axios({
          withCredentials: true,
          crossDomain: true,
          method: "get",
          url:quiz_answer,
          params: {
            tid: this.msg.id,
            option: idx,
            points: arr[idx - 1]
          }
        }).then(res => {
          let { data } = res;
          if (data.code == -1) {
            this.$emit("login", data.msg);
          } else {
            this.$emit("login", "竞猜成功");
            this.$emit("deduct", { type: "guess", num: 50 });
          }
          this.initGuess();
        });
      } else {
        this.$emit("login", "请下载安装雷电圈APP");
      }
    },
    initGuess() {
      this.$axios({
        withCredentials: true,
        crossDomain: true,
        method: "get",
        url:quiz_topic
      }).then(res => {
        let { data } = res.data;
        let num = 0;
        this.msg = data[0];
        for (let i = 1; i <= 4; i++) {
          if(this.msg[`option${i}Num`]){
            num += this.msg[`option${i}Num`];
          }
        }
        this.allpoints = num * 50;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.content {
  height: 566px;
  .rule {
    padding: 0 88px;

    display: flex;
    justify-content: flex-end;
    i {
      display: block;
      width: 25px;
      height: 25px;
      margin-right: 5px;
      background: url("../assets/small.jpg") no-repeat;
      background-size: 100% 100%;
    }
    .ruleMsg {
      display: block;
      font-size: 22px;
      display: flex;
      span {
        display: block;
        height: 24px;
        border-bottom: 1px solid #000;
      }
    }
  }
  .common {
    height: 540px;
    box-sizing: border-box;
  }
  .guessing {
    padding-top: 38px;
    .msg {
      font-size: 34px;
      text-align: center;
      font-weight: 600;
      color: linear-gradient(to right, #d753f0, #763ace);
    }
    .count {
      font-size: 16px;
      margin-top: 38px;
      text-align: center;
    }
    .num {
      font-size: 44px;
      color: #7e39d1;
      font-weight: 600;
      margin-top: 20px;
      text-align: center;
      margin-bottom: 30px;
    }
    .photo {
      height: 4px;
      width: 485px;
      margin: 10px auto 0;
      background: url("../assets/liner.png") no-repeat;
      background-size: 100% 100%;
    }
    .choice {
      // height: 234px;
      height: 180px;
      display: flex;
      justify-content: space-around;
      position: relative;
      .vs {
        position: absolute;
        left: 50%;
        top: 50%;
        // transform: translate(-35%, -20%);
        transform: translate(-50%,-50%);
        font-size: 50px;
        font-weight: 900;
        color: #39455a;
      }
      .select {
        height: 100%;
        // width: 285px;
        width: 250px;
        position: relative;
        img {
          width: 100%;
          height: 100%;
        }
        p {
          position: absolute;
          // top: 97px;
          top:50%;
          left:50%;
          transform: translate(-50%,-50%);
          width: 100px;
          display: flex;
          flex-direction: column;
          text-align: center;
          font-size: 44px;
          color: #fff;
          span {
            margin-top: 10px;
            font-size: 22px;
          }
        }
        
      }
    }
  }
}
</style>
